<!--
Copyright 2026 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<div
  class="submission-response-geometry"
  [ngClass]="{
    'selected-submission-response-geometry': isSelected(),
  }"
  (click)="onClick()"
>
  <div
    class="submission-response-geometry-number"
    [ngStyle]="{ 'background-color': jobColor() ?? 'black' }"
  >
    {{ displayIndex() }}
  </div>
  <div
    *ngIf="
      !capturedCoord() &&
      (task().type === taskType.DROP_PIN || task().type === taskType.DRAW_AREA)
    "
    class="submission-response-geometry-label"
  >
    {{ task().id }}
  </div>
  <div *ngIf="capturedCoord()" class="submission-response-geometry-label">
    {{ capturedCoord() }}
  </div>
</div>
